import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

interface QuoteRejectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (notes: string) => void;
  isLoading?: boolean;
}

export function QuoteRejectionDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: QuoteRejectionDialogProps) {
  const { t } = useTranslation();
  const [notes, setNotes] = useState("");

  const handleConfirm = () => {
    onConfirm(notes);
    setNotes(""); // Clear notes after confirmation
  };

  const handleCancel = () => {
    setNotes(""); // Clear notes on cancel
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("components.quoteRejectionDialog.rejectQuote")}</DialogTitle>
          <DialogDescription>
            {t("components.quoteRejectionDialog.pleaseProvideAReason")}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <label htmlFor="rejection-notes" className="text-sm font-medium">
              {t("components.quoteRejectionDialog.reasonForRejectionOptional")}
            </label>
            <Textarea
              id="rejection-notes"
              placeholder={t("components.quoteRejectionDialog.eGPriceIs")}
              value={notes}
              onChange={(e) => setNotes(e.target.value.slice(0, 270))}
              className="mt-2"
              rows={4}
              maxLength={270}
            />
            <div className="text-xs text-muted-foreground text-right mt-1">
              {notes.length}{t("components.quoteRejectionDialog.270Characters")}
            </div>
          </div>
        </div>

        <DialogFooter className="flex space-x-2">
          <Button variant="outline" onClick={handleCancel} disabled={isLoading}>
            {t("common.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? t("components.quoteRejectionDialog.rejecting") : t("components.quoteRejectionDialog.rejectQuote")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
